import { render } from "./WhitelistedTypeLogo.vue?vue&type=template&id=5ee273b4"
import script from "./WhitelistedTypeLogo.vue?vue&type=script&lang=js"
export * from "./WhitelistedTypeLogo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leopons/Desktop/Projects/cryptos/bubble-graph/bubblemaps-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__